import { render, staticRenderFns } from "./AttachmentDialog.vue?vue&type=template&id=224bfaa6&scoped=true"
import script from "./AttachmentDialog.vue?vue&type=script&lang=js"
export * from "./AttachmentDialog.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDialog.vue?vue&type=style&index=0&id=224bfaa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224bfaa6",
  null
  
)

export default component.exports